import React from 'react';
import { Box, Container, Typography, Divider, Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'background.paper',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        mt: 'auto',
        py: 4,
      }}
    >
      <Container maxWidth="lg">
        <Divider sx={{ mb: 3 }} />
        
        {/* Footer Links */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: { xs: 'center', md: 'flex-start' } }}>
              <Button 
                variant="text" 
                size="small" 
                onClick={() => navigate('/terms-and-conditions')}
                sx={{ textTransform: 'none' }}
              >
                Terms & Conditions
              </Button>
              <Button 
                variant="text" 
                size="small" 
                onClick={() => navigate('/rules')}
                sx={{ textTransform: 'none' }}
              >
                Competition Rules
              </Button>
              <Button 
                variant="text" 
                size="small" 
                onClick={() => navigate('/contact')}
                sx={{ textTransform: 'none' }}
              >
                Contact Support
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: { xs: 'center', md: 'flex-end' } }}>
              <Button 
                variant="text" 
                size="small" 
                sx={{ textTransform: 'none' }}
                onClick={() => navigate('/privacy-policy')}
              >
                Privacy Policy
              </Button>
              <Button 
                variant="text" 
                size="small" 
                onClick={() => navigate('/prizes')}
                sx={{ textTransform: 'none' }}
              >
                Prizes
              </Button>
              <Button 
                variant="text" 
                size="small" 
                onClick={() => navigate('/leaderboard')}
                sx={{ textTransform: 'none' }}
              >
                Leaderboard
              </Button>
            </Box>
          </Grid>
        </Grid>
        
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: 'primary.main', textAlign: 'center' }}>
          Trading Risk Disclaimer
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ 
            lineHeight: 1.6,
            textAlign: 'center',
            maxWidth: '100%'
          }}
        >
          Trading in financial markets carries a high level of risk and may not be suitable for all investors. 
          Before deciding to trade, you should carefully consider your investment objectives, level of experience, 
          and risk appetite. The possibility exists that you could sustain a loss of some or all of your initial 
          investment and therefore you should not invest money that you cannot afford to lose. You should be aware 
          of all the risks associated with trading and seek advice from an independent financial advisor if you 
          have any doubts. Past performance is not indicative of future results.
        </Typography>
        
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            © 2025 FX Wars. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 